<template>
  <div class="robot-list">
    <div class="banner">
      <img src="@/assets/images/robot/banner.png" alt="">
    </div>
    <div class="robot-header">
      <div class="title">{{msgInfo.title}}</div>
      <div class="decs">{{msgInfo.subtitle}}</div>
    </div>
    <div class="robot-content">
      <RobotCard v-for="item in cardData" :key="item.id" :data="item" @onClick="onClick" :topicType="RobotCard" width="27.466667vw"></RobotCard>
      <div class="data-source">*数据来源于博智林机器人实验室</div>
    </div>
  </div>
</template>
<script>
import RobotCard from "@/components/RobotCard.vue";
// import { cardData } from "./robot";
import  {getContents} from '@/api/cms.js'


export default {
  name: 'robot-list',
  components: {
    RobotCard
  },
  data () {
    return {
      msgInfo: {
        title: "建筑机器人",
        desc: "博智林自研建造全周期多类型建筑机器人，系统化提升安全、质量、效率等建造全过程综合效益。"
      },
      cardData: [],
    }
  },
  mounted() {

    this.initData();
  },

  methods: {
    onClick(value){
      this.$router.push({path: '/robot-detail', query:{
        id: value
      }})
    },
   async initData() {

        //channelTemplateId
       let contents = await this.$getContents(this.$channels.robotList);
       console.log("data.contents", contents)

       contents.forEach(
           item => {
               this.cardData.push({
                   id: item.id,
                   avatar: process.env.VUE_APP_BASE_API+item.imageUrl,
                   img: process.env.VUE_APP_BASE_API+item.imageUrl,
                   title: item.title,
                   subtitle: item.subTitle,
                   desc: item.body.replace(/<[^>]+>/g,""),
                   summary:item.summary.length>46 ? item.summary.substr(0,45)+"..." : item.summary
               })
            }
       );
       //this.$root.ROBOT_CONTENTS = this.cardData ;
       console.log("ROBOT_CONTENTS",contents)
   },

  }
}
</script>
<style lang="less" scoped>
.robot-list {
  .banner {
    img {
      width: 750px;
      height: 250px;
    }
  }
  .robot-header {
    padding: 100px 48px 32px;
    border-bottom:  1px solid #f0f0f0;
    .title {
      font-size: 48px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #333333;
      margin-bottom: 32px;
    }
    .decs {
      font-size: 28px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #666666;
      line-height: 56px;
    }
  }
  .robot-content{
    padding-bottom: 132px;
  }
  .data-source{
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #999999;
    margin-top: 64px;
    margin-left: 48px;
  }
}
</style>



